// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  defaultContext,
  QueryClient,
  QueryClientProvider
} from '/root/workspace/idp-compose-fe_vwA0/node_modules/.pnpm/@tanstack+react-query@4.29.12_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query';
import { ReactQueryDevtools } from '/root/workspace/idp-compose-fe_vwA0/node_modules/.pnpm/@tanstack+react-query-devtools@4.29.12_@tanstack+react-query@4.29.12_react-dom@18.3.1_react@1_wpwzmld7x6dh7e4sahyrcfnp3i/node_modules/@tanstack/react-query-devtools';
const reactQueryConfig = {};
const client = new QueryClient(reactQueryConfig.queryClient || {});
export function rootContainer(container) {
  return (
    <QueryClientProvider
      client={client}
      context={defaultContext}
    >
      {container}
      <ReactQueryDevtools
  context={defaultContext}
  initialIsOpen={false}
  {...(reactQueryConfig.devtool || {})}
/>
    </QueryClientProvider>
  );
}
